export function formatDuration(startIso: string, endIso: string): string {
  const startMs = new Date(startIso).getTime();
  const endMs = new Date(endIso).getTime();
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) {
    return '—';
  }
  const mins = Math.round((endMs - startMs) / 60_000);
  if (mins <= 0) {
    return '—';
  }
  const hrs = Math.floor(mins / 60);
  const rem = mins % 60;
  if (hrs === 0) {
    return `${rem} min`;
  }
  if (rem === 0) {
    return `${hrs} hr`;
  }
  return `${hrs} hr ${rem} min`;
}

export function formatShortDate(isoString: string | null | undefined): string {
  if (!isoString) {
    return '—';
  }
  const date = new Date(isoString);
  if (isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
